/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Row, Col, Select, Spin, Popover, Radio, Tooltip } from 'antd'
import { Router, Link } from 'react-router-dom'
import history from '../../History'
import './download-history.css'
import moment from 'moment'
import {
  handleMineOrAll,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory,
} from '../../actions/DownloadAction'
import { getSearchResult } from '../../actions/SearchAction'
import { sendNotification, processDownloadHistory } from '../../utils'
import BunkeyAPI from '../../api/BunkeyAPI'

const { Option } = Select
const spinnerStyle = {
  textAlign: 'center',
  borderRadius: 4,
  marginBottom: 20,
  padding: '30px 50px',
  margin: '20px 0'
}

export class DownloadHistory extends Component {

  constructor(props) {
    super(props)
    this.state = {
      breadCrumbs: [],
      order: {
        field: ['createdAt'],
        type: 'asc',
        limit: 30,
        page: 1,
      },
      downloadHistory: [],
    }
  }

  componentDidMount() {
    const { mine, user, defaultListDownloadHistory } = this.props
    const { order } = this.state
    const query = mine
      ? [{
        field: 'user',
        type: 'eq',
        value: user._id,
      }]
      : []
    this.handleFilterChange(defaultListDownloadHistory, order, query)
  }

  componentDidUpdate(prevProps) {
    const { mine, defaultListDownloadHistory, refreshDownloadHistory } = this.props
    if (prevProps.mine !== mine) {
      this.handleFilterChange(defaultListDownloadHistory)
    }
    if (prevProps.refreshDownloadHistory !== refreshDownloadHistory) {
      this.handleFilterChange(defaultListDownloadHistory)
    }
  }
  /**
   * @name handleFilterChange
   * @author Victor Smith
   */
  handleFilterChange = filter => {
    const { order } = this.state
    const { user, mine, workclient, intl } = this.props
    this.props.handleIsFetchingHistory(true)

    let query = [{
      field: 'user',
      type: 'eq',
      value: user._id,
    }]

    switch (filter) {
      case 'videos':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'video',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'images':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'image',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'documents':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'document',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'folders':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'folder',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'notDownloaded':
        query = [
          ...query, {
            field: 'status',
            type: 'eq',
            value: 'error',
          },
        ]
        break;
      default:
        query = [
          ...query,
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
    }

    if (!mine) {
      query.shift()
    }

    BunkeyAPI({
      url: query
        ? `/downloads/client/${workclient}?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`
        : `/downloads/client/${workclient}?order=${JSON.stringify(order)}`,
      method: 'GET',
    }).then(resp => {
      const { data } = resp
      this.props.handleIsFetchingHistory(false)
      this.setState({ downloadHistory: processDownloadHistory(data) })
      this.props.handleRefreshDownloadHistory(false)
    }).catch(err => {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_getting_downloads_list' }))
    })

    this.props.handleDefaultListDownloadHistory(filter)
  }
  /**
   * @name handleCahngeMineOrAll
   * @author Victor Smith
   */
  handleCahngeMineOrAll = e => {
    this.props.handleMineOrAll(e.target.value)
  }
  /**
   * @name handleGetBreadCrumbs
   * @author Victor Smith
   */
  handleGetBreadCrumbs = item => {
    const { breadcrumb } = this.props
    let route = []
    // --->
    item.parents.forEach(i => {
      breadcrumb.forEach(b => {
        if (i === b._id)
          route.push({ id: b._id, name: b.name })
      })
    })
    // --->
    return route
  }
  /**
   * @name handleGoToAsset
   * @author Victor Smith
   */
  handleGoToAsset = asset => {
    const { document: { client, _id, name } } = asset
    this.props.getSearchResult(client, name, '', 1, null, _id)
    this.props.handleShowHideDetailDrawer()
  }

  render() {
    const {
      intl,
      newColor,
      user,
      isFetchingHistory,
      mine,
      defaultListDownloadHistory,
      root,
    } = this.props

    const { downloadHistory } = this.state
    const isOperator = user.role !== 'admin' && user.clientRole !== 'admin'

    return (<React.Fragment>
      <Row>
        <Col span={12}>
          <Radio.Group onChange={this.handleCahngeMineOrAll} defaultChecked={mine} value={mine} size="small">
            <Radio value={true} >{intl.formatMessage({ id: "my_user" })}</Radio>
            {!isOperator && <Radio value={false} >{intl.formatMessage({ id: "all_users" })}</Radio>}
          </Radio.Group>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Select defaultValue={defaultListDownloadHistory}
            className='arrowSelect'
            onChange={this.handleFilterChange}
            style={{ size: 'small', width: 130, color: newColor }}
            dropdownStyle={{ position: "fixed" }}>
            <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
            <Option value="videos">{intl.formatMessage({ id: "searche_tooltip_video" })}</Option>
            <Option value="images">{intl.formatMessage({ id: "searche_tooltip_image" })}</Option>
            <Option value="documents">{intl.formatMessage({ id: "documents" })}</Option>
            <Option value="folders">{intl.formatMessage({ id: "folders" })}</Option>
            <Option value="notDownloaded">{intl.formatMessage({ id: "notDownloaded" })}</Option>
          </Select>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px', height: '74vh' }}>
        <Router history={history}>
          <div className='dh-container-list'>
            {isFetchingHistory && <div style={spinnerStyle}><Spin spinning={isFetchingHistory} /></div>}
            {!isFetchingHistory && <ul>
              {downloadHistory.map((d, k) => <div key={k}>
                {d.typeItem === 'date' && <div className='dh-container-badge '>
                  <span className='dh-badge'>{moment(new Date()).format('DD/MM/YYYY') === moment(d.date).format('DD/MM/YYYY')
                    ? intl.formatMessage({ id: 'today' })
                    : `${moment(d.date).format('dddd')}  ${moment(d.date).format('DD/MM/YYYY')}`}</span>
                </div>}
                {d.typeItem === 'download' && <span>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: 'go_to_asset' })}
                    overlayStyle={{ fontSize: '10px' }}>
                    <div
                      data-icon="a"
                      className="icon"
                      style={{ marginRight: 10, float: 'right', cursor: 'pointer' }}
                      onClick={() => this.handleGoToAsset(d)}></div>
                  </Tooltip>
                  <Popover placement="left" content={<div className='dh-popover'>
                    <p>
                      <b>{intl.formatMessage({ id: 'name' })}:</b> <span>{d.name.length > 40
                        ? `${d.name.substring(0, 37)}...`
                        : d.name}
                      </span>{d.type === 'folder' && <span>.zip</span>}
                    </p>
                    {d.document.fileSizeFormat && <p>
                      <b>{intl.formatMessage({ id: 'weight' })}:</b> <span>{d.document.fileSizeFormat}</span>
                    </p>}
                    {!isOperator && <p>
                      <b>{intl.formatMessage({ id: 'download_by' })}:</b> <span>{d.user_creator.name}</span>
                    </p>}
                    {<p>
                      <b>{intl.formatMessage({ id: 'type' })}:</b> <span>{
                        d.typeItem === 'download' && d.type !== 'folder'
                          ? d.document.originalURL.split('.').slice(-1)
                          : intl.formatMessage({ id: 'folder' })
                      }</span>
                    </p>}
                    <p>
                      <b>{intl.formatMessage({ id: 'asset_location' })}:</b><span>
                        <span><Link
                          to={`/home/`}
                          style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                          {intl.locale === 'es' ? '/Bunkers/' : '/Home/'}
                        </Link></span>
                        {
                          this.handleGetBreadCrumbs(d.document).map((r, k) => <Link to={`/home/explore/${r.id}`}
                            key={k}
                            style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                            {r.name}/
                        </Link>)
                        }</span>
                      {d.location === root && <Link
                        to={`/home/explore/${d.document._id}`}
                        style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                        {d.document.name}
                      </Link>}
                    </p>
                    {/* <p><b>{intl.formatMessage({ id: 'times_downloaded' })}:</b> <span> -- </span></p> */}
                  </div>} title="Title">
                    <li key={k} className='dh-li' style={{ backgroundColor: k % 2 !== 0 ? '#f2f2f2' : '#fffff' }} >
                      {d.name.length > 40
                        ? `${d.name.substring(0, 37)}...`
                        : d.name}
                      {d.type === 'folder' && <span>.zip</span>}
                    </li>
                  </Popover>
                </span>}
              </div>)}
            </ul>}
            {!isFetchingHistory && downloadHistory.length === 0 && <div style={{ textAlign: 'center' }}>
              <p>{intl.formatMessage({ id: 'no_download_data' })}</p>
            </div>}
          </div>
        </Router>
      </Row >
    </React.Fragment >)
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    defaultListDownloadHistory: state.downloads.defaultListDownloadHistory,
    user: state.authUser.user,
    isFetchingHistory: state.downloads.isFetchingHistory,
    mine: state.downloads.mine,
    breadcrumb: state.client.breadcrumb,
    root: state.client.root,
    workclient: state.client.workclient,
    refreshDownloadHistory: state.downloads.refreshDownloadHistory,
  }
}

const mapDispatchToProps = {
  handleMineOrAll,
  getSearchResult,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory,
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadHistory)))